import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { PROFESSIONAL_LEVELS } from '#/utils/constants/general/professionalLevels';

export function professionalLevelFacet(i18n: I18nFn) {
  return {
    id: 'professionalLevelFacet',
    name: 'professionalLevel',
    get title() {
      return i18n('Experience Level');
    },
    type: 'array',
    options: Object.keys(PROFESSIONAL_LEVELS(i18n)),
    optionTitles: PROFESSIONAL_LEVELS(i18n),
    sort: false,
  } as const satisfies SearchFacetData;
}
